import {Footer} from "@/components/layouts/main/Footer";
import {RootHeader} from "@/components/layouts/main/RootHeader";
import {Cases} from "@/pages/common/Home/Cases";
import {Dissection} from "@/pages/common/Home/Dissection";
import {Article} from "@/pages/common/Home/Dissection/Article";
import {Features} from "@/pages/common/Home/Features";
import {Login} from "@/pages/common/Home/Login";
import {Overview} from "@/pages/common/Home/Overview";
import {Suit} from "@/pages/common/Home/Suit";
import {HeroVideo} from "@/pages/common/Home/components/HeroVideo";
import {ScrollBtn} from "@/pages/common/Home/components/ScrollBtn";

import {useEffect, useState} from "react";

import {Route, Routes, useLocation} from "react-router-dom";

export const Home = () => {
  const location = useLocation();

  const [isScrollBtnVisible, setScrollBtnVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({top: 0, behavior: "smooth"});
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 950) {
        setScrollBtnVisible(true);
      } else {
        setScrollBtnVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <RootHeader />

      <HeroVideo
        hero
        top={!location.pathname.includes("overview") ? "-550" : "-260"}
      />

      <Routes>
        <Route
          path={"overview"}
          element={<Overview />}
        />
        <Route
          path={"features/*"}
          element={<Features />}
        />
        <Route
          path={"cases"}
          element={<Cases />}
        />
        <Route
          path={"articles"}
          element={<Dissection />}
        />
        <Route
          path={"article/:id/:title"}
          element={<Article />}
        />
        <Route
          path={"suit"}
          element={<Suit />}
        />
        <Route
          path={"login"}
          element={<Login />}
        />
      </Routes>

      {isScrollBtnVisible && <ScrollBtn click={scrollToTop} />}

      <Footer />
    </>
  );
};
